/* Short page transitions without replacing the seasonal shell or cart logic. */
(() => {
 const main=document.querySelector('main'),root=document.documentElement;
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 let entrance,leaving=false,revealed=false;
 window.animatePageRegion=function(host){
  if(reduced.matches)return;
  const animation=host.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'cubic-bezier(.22,.8,.2,1)'});
  window.dispatchEvent(new CustomEvent('glass:motion',{detail:{host,animation}}));
  return animation;
 };
 window.revealPage=function(){
  if(revealed)return;revealed=true;
  root.classList.remove('page-entering');main.removeAttribute('aria-busy');
  entrance=window.animatePageRegion(main);
 };
 main.setAttribute('aria-busy','true');
 // Catalog pages reveal once their data and markup are ready, avoiding a second jump.
 addEventListener('DOMContentLoaded',()=>{
  if(!['index','collection','product'].includes(window.shopRoute))window.revealPage();
 });
 setTimeout(window.revealPage,1200);
 // Warm likely destinations without navigating or changing history.
 const prefetched=new Set();
 function localDestination(link){
  if(!link||link.hasAttribute('download')||(link.target&&link.target!=='_self'))return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||/^\/(?:checkout|account|customer_authentication|orders|admin)(?:\/|$)/.test(url.pathname))return;
  if(url.pathname===location.pathname&&url.search===location.search)return;
  return url;
 }
 function prefetch(e){
  const url=localDestination(e.target.closest?.('a[href]'));
  if(!url||prefetched.has(url.href))return;
  if(navigator.connection?.saveData)return;
  prefetched.add(url.href);const hint=document.createElement('link');hint.rel='prefetch';hint.href=url.href;hint.as='document';document.head.append(hint);
 }
 document.addEventListener('pointerover',prefetch,{passive:true});
 document.addEventListener('focusin',prefetch);
 document.addEventListener('click',e=>{
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const url=localDestination(e.target.closest?.('a[href]'));if(!url||reduced.matches)return;
  e.preventDefault();if(leaving)return;leaving=true;entrance?.cancel();
  const animation=main.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-6px)'}],{duration:90,easing:'ease-out',fill:'forwards'});
  window.dispatchEvent(new CustomEvent('glass:motion',{detail:{host:main,animation}}));
  animation.finished.catch(()=>{}).then(()=>location.assign(url.href));
 });
 // A restored browser-history snapshot must not keep the outgoing fade.
 addEventListener('pageshow',e=>{
  if(!e.persisted)return;
  for(const animation of main.getAnimations())animation.cancel();
  leaving=false;revealed=false;window.revealPage();
 });
})();
